var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-name"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "name"
  }, [_c('a', {
    attrs: {
      "href": ("/companies/" + (_vm.company.id))
    }
  }, [_vm._v(_vm._s(_vm.company.name))])])], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c7c62e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/name.vue
// module id = null
// module chunks = 